import { useSelector } from "react-redux";
import { selectCurrent } from "../../../redux/settings/selectors";
import { selectWebsiteCardsListItems } from "../../../redux/websiteCards/selector";
import { useEffect, useState } from "react";
import storePersist from "../../../redux/storePersist";
import { useAppDispatch } from "../../../hooks/hooks";
import { websiteCards } from "../../../redux/websiteCards/action";
import _ from 'lodash'
import { getCardData } from "../../../common/services/website-card.service";
import { guestToken } from "../../../redux/auth/actions";
import { queryByStore } from "../../../redux/query-by-store/action";
import { organizationUnits } from "../../../redux/organizationUnits/action";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { websites } from "../../../redux/websites/action";
import { settings } from "../../../redux/settings/actions";
import GetQuote from "../../../models/GetQuote";
import { Carousel } from 'react-responsive-carousel';
import GoogleMapSearch from "../../../common/components/google-map-search";
import { leads } from "../../../redux/leads/action";
import { cmsSettings } from "../../../redux/cmsSettings/action";
import useWindowDimensions from "../../../hooks/useWindowsDimensions";
import { useNavigate } from "react-router-dom";
import { selectOrganizationUnitsListItems } from "../../../redux/organizationUnits/selector";
import { products } from "../../../redux/products/action";
import { selectProductsListItems } from "../../../redux/products/selector";
import { selectLeadsCreatedItem } from "../../../redux/leads/selector";


const MobilityHome = () => {
	const dispatch = useAppDispatch()
	let navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { tenantId, lightLogo, darkLogo } = result
	const productListData = useSelector(selectProductsListItems)
	const [generateIds, setGenerateIds] = useState<any>([]);
	const [leadValues, setLeadValues] = useState<any>()
	const leadCreateData = useSelector(selectLeadsCreatedItem)
	const [isLead, setIsLead] = useState<boolean>(false)
	const dummyImage = require(`../../../assets/img/image.png`)


	const [searchedLocation, setSearchedLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});


	const [searchedToLocation, setSearchedToLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});

	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
	}
	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};

	// Deferred API
	const deferredAPICalls = async () => {
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(products.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`, entity: 'products', jsonData: {} }))
			await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
			await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
			await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
			await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
		}

	}

	// app initialization
	useEffect(() => {
		(async () => {
			if (tenantId) {
				dispatch(leads.resetAction({ actionType: 'create' }))
				localStorage.removeItem('access-token')
				localStorage.removeItem('accessTokenMetadata')
				localStorage.removeItem('userProfile')
				deferredAPICalls();

			}
			generateIdValue()
		})();
	}, [tenantId]);

	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};


	const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_BANNER') : null;

	const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

	const workProcessHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_WORK_PROCESS_HEADING') : null;

	const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

	const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_E_MOBILITY') : null;

	const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

	const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_HOME_MAIN_PAGE_SERVICE') : null;

	const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'MOBILITY_SMP_COPYRIGHTS') : null;

	const banner = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../../assets/img/logisticsBanner.png'))

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}

	const handleSubmit = async (event: any) => {
		event?.preventDefault()
	await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(leads.create({
			url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads`, entity: 'leadCreate', jsonData: {
				"Records": [
					{
						LeadInfo: {
							Name: leadValues?.name || null,
							Description: leadValues?.description,
							Email: leadValues?.email || null,
							PhoneNumber: leadValues?.phone || null,
							//MobilityProductTypeId: selected,
							MobilityProductId: leadValues?.mobilityProdcutId,
							IsVariant: false,
							MobilityVariantId: 0,
							IsExistingUser: leadValues?.IsExistingUser || false
						},
					}
				]
			}
		}))
		
			// dispatch(settings.set({
			// 	quoteData: leadValues,

			// }))
			await setIsLead(true)
			// dispatch(settings.set({ getQuote: 'open' }))
			

	}
	useEffect(() => {
		if (leadCreateData?.isSuccess && isLead) {
			dispatch(settings.set({
				quoteData: leadValues,
				searchedLocation,
				searchedToLocation,
				isLead:isLead
			}))
			
			setLeadValues({
				Name: '',
				Email: '',
				PhoneNumber: '',
				date: '',
				IsExistingUser: '',
			})
			setIsLead(false)
			navigate('/auth/login-with-OTP', {
				state:
					{ pageName: 'rsa' }
			})
		}
	}, [isLead])



	return (
		<div className={`flex flex-col items-center justify-center w-full bg-white`} >
		

			{/* Banner Section */}
			<div className="flex flex-col items-center justify-center w-full" style={{
				backgroundImage: `url(${banner})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat'
			}}>
				<div className="flex justify-around items-center p-1 w-full h-[620px] px-10">
					<div className="flex flex-col justify-between items-center w-1/2">
					</div>
					<div className={`w-1/3 justify-center item-center mt-56 rounded-2xl bg-white`}>
						<div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
							<div className="text-2xl text-primary font-bold py-5">Instant Quote Calculator</div>
							<div className=" w-full px-3 font-bold space-y-2">
								<div className="flex flex-row ">
									<div className=" w-full text-xs flex flex-row justify-start items-center">
										<input
											type="checkbox"
											name={"from"}
											placeholder=""
											className={`px-2 bg-primary text-xs px-3`}
											onChange={(event) => {
												handleChange(
													event.target.checked,
													'IsExistingUser'
												)
											}}
											value={leadValues?.IsExistingUser}
										/>
										<div className="mx-2">Are You Already Register?</div>
									</div>
								</div>
								{!leadValues?.IsExistingUser ? <>
									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">
											{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Name
														</label> */}
											<div className="border-0 font-normal ">
												<input
													type="text"
													name={"Name"}
													placeholder="Full Name"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleChange(
															event.target.value,
															'name'
														);
													}}
													value={leadValues?.name} />
											</div>
										</div>

									</div>
									<div className="flex flex-row space-x-2 ">
										<div className=" w-full">
											{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Mobile
														</label> */}
											<div className="border-0 font-normal">
												<input
													type="number"
													name={"PhoneNumber"}
													placeholder="Phone Number"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleChange(
															event.target.value,
															'phone'
														);
													}}
													value={leadValues?.phone} />
											</div>
										</div>
										<div className=" w-full">
											{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Email
														</label> */}
											<div className="border-0   font-normal">
												<input
													type="email"
													name={"Email"}
													placeholder="Email"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event) => {
														handleChange(
															event.target.value,
															'email'
														);
													}}
													value={leadValues?.email} />
											</div>
										</div>

									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full  ">
											{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
											<div className="border-0   font-normal">
												<select
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													id="default"

													onChange={(event: any) => {
														handleChange(
															event.target.value, 'mobilityProdcutId'
														)
													}}
													value={leadValues?.mobilityProdcutId}
												>

													<option className={`w-full py-3 px-3 border-b-2 border-black text-base `}>Choose Product</option>
													{productListData?.result?.items?.map((item: any, index: any) => (
														<option value={item.Id} key={index}>{item.Name}</option>
													)
													)}

												</select></div>

										</div>
									</div>

									<div className="flex flex-row space-x-2 ">
										<div className=" w-full ">
											{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
											<div className="border-0   font-normal">
												<textarea
													name={"description"}
													placeholder="Description"
													className={`w-full py-3 px-3 border-b-2 border-black text-base `}
													onChange={(event: any) => {
														handleChange(
															event.target.value, 'description'
														)
													}}
													value={leadValues?.description}
												/></div>


										</div>
									</div>


								</> :
									<>
										<div className="flex flex-row space-x-2">
											<div className=" w-full">
												{/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Login with Email or PhoneNumber
															</label> */}
												<div className="border-0  font-normal">
													<input
														type="email"
														name={"Email"}
														placeholder="Email"
														className={`w-full py-3 px-3 border-b-2 border-black text-base `}
														onChange={(event) => {
															handleChange(
																event.target.value,
																'email'
															);
														}}
														value={leadValues?.email} />
												</div>
											</div>

										</div>
										<div className="flex flex-row space-x-2 ">
											<div className=" w-full  ">
												{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
												<div className="border-0   font-normal">
													<select
														className={`w-full py-3 px-3 border-b-2 border-black text-base `}
														id="default"

														onChange={(event: any) => {
															handleChange(
																event.target.value, 'mobilityProdcutId'
															)
														}}
														value={leadValues?.mobilityProdcutId}
													>

														<option className={`w-full py-3 px-3 border-b-2 border-black text-base `}>Choose Product</option>
														{productListData?.result?.items?.map((item: any, index: any) => (
															<option value={item.Id} key={index}>{item.Name}</option>
														)
														)}

													</select></div>

											</div>
										</div>

										<div className="flex flex-row space-x-2 ">
											<div className=" w-full ">
												{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
												<div className="border-0   font-normal">
													<textarea
														name={"description"}
														placeholder="Description"
														className={`w-full py-3 px-3 border-b-2 border-black text-base `}
														onChange={(event: any) => {
															handleChange(
																event.target.value, 'description'
															)
														}}
														value={leadValues?.description}
													/></div>


											</div>
										</div>
									</>
								}

							</div>
							{/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

							<div className={`bg-primary px-5 flex w-full flex-row flex item-center justify-center mt-5 mb-10 `}>
								<div
									onClick={handleSubmit}
									className="text-base text-light my-3 font-bold cursor-pointer">
									Get Quote
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Section 2 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full `}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold ">
							{workProcessHeading ? workProcessHeading[0]?.title : 'Heading'}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10">
						{/* Card 1 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">

								<img src={workProcessData && workProcessData[0]?.src ? workProcessData[0]?.src : dummyImage} alt="card-image" className="object-cover w-full h-full" />

							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[0]?.title : 'Title'}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[0]?.description : 'Description'}
							</div>
						</div>

						{/* Card 2 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">

								<img src={workProcessData && workProcessData[1]?.src ? workProcessData[1]?.src : dummyImage} alt="card-image" className="object-cover w-full h-full" />

							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[1]?.title : "Title"}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[1]?.description : 'Description'}
							</div>
						</div>

						{/* Card 3 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">

								<img src={workProcessData && workProcessData[2]?.src ? workProcessData[2]?.src : dummyImage} alt="card-image" className="object-cover w-full h-full" />

							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[2]?.title : 'Title'}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[2]?.description : 'Description'}
							</div>
						</div>

						{/* Card 4 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">

								<img src={workProcessData && workProcessData[3]?.src ? workProcessData[3]?.src : dummyImage} alt="card-image" className="object-cover w-full h-full" />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[3]?.title : 'Title'}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[3]?.description : 'Description'}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Section 3 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full`}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold ">
							{eMobilityHeading ? eMobilityHeading[0]?.title : "Heading"}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10 ">
						{/* Card 1 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary`}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[0]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl  text-light">
								{eMobilityData ? eMobilityData[0]?.title : 'Title'}
							</div>

						</div>

						{/* Card 2 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[1]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl  text-light">
								{eMobilityData ? eMobilityData[1]?.title : 'Title'}
							</div>

						</div>

						{/* Card 3 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[2]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl  text-light">
								{eMobilityData ? eMobilityData[2]?.title : 'Title'}
							</div>

						</div>

						{/* Card 4 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[3]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl  text-light">
								{eMobilityData ? eMobilityData[3]?.title : 'Title'}
							</div>

						</div>
					</div>
				</div>
			</div>

			{/* Section 4 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full `}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold ">
							{serviceHeading ? serviceHeading[0]?.title : 'Heading'}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full my-10 mx-5 px-20">
						{/* Card 1 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								{/* <svg height="150" width="150" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#233c64" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> </style> <g> <path d="M447.77,33.653c-36.385-5.566-70.629,15.824-82.588,49.228h-44.038v37.899h40.902 c5.212,31.372,29.694,57.355,62.855,62.436c41.278,6.316,79.882-22.042,86.222-63.341C517.428,78.575,489.07,39.969,447.77,33.653z "></path> <path d="M162.615,338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891,0-12.467,5.588-12.467,12.468 c0,6.868,5.576,12.467,12.467,12.467h53.988C157.038,350.689,162.615,345.091,162.615,338.222z"></path> <path d="M392.999,237.965L284.273,340.452l-37.966,9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732 c16.95-2.418,29.396-6.692,44.336-15.018l46.302-24.228v104.432h132.435V270.828C504.927,202.618,428.016,202.43,392.999,237.965z M215.996,448.913H30.313v-155.37h185.683v63.805l-36.419,9.01c-15.968,4.395-25.708,20.518-22.174,36.696l0.298,1.247 c3.478,15.912,18.651,26.436,34.785,24.14l23.51-3.788V448.913z"></path> </g> </g></svg> */}
								<HTMLContent htmlContent={serviceData ? serviceData[0]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[0]?.title : 'Title'}
							</div>
							{/* <div className="flex-grow p-1 text-center text-base min-h-[60px]">
										{serviceData ? serviceData[0]?.subTitle : null}
									</div> */}
						</div>
						<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
						{/* Card 2 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">

							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								<HTMLContent htmlContent={serviceData ? serviceData[1]?.description : 'SVG'} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[1]?.title : 'Title'}
							</div>
							{/* <div className="flex-grow p-1 text-center text-base min-h-[60px]">
										{serviceData ? serviceData[1]?.subTitle : null}
									</div> */}

						</div>
						<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
						{/* Card 3 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								<HTMLContent htmlContent={serviceData ? serviceData[2]?.description : 'SVG Icon'} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[2]?.title : 'Title'}
							</div>
							{/* <div className="flex-grow p-1 text-center text-base min-h-[60px]">
										{serviceData ? serviceData[2]?.subTitle : null}
									</div> */}
						</div>



					</div>
				</div>
			</div>


		</div >
	)
}

export default MobilityHome
